import { useTranslation } from "react-i18next";
import documentsClient from "../../../api/private/documentsClient";
import { Modal } from "../../../components";
import SendByEmailForm from "../../../components/forms/documents/SendByEmailForm";

import {
  CPCustomFormReportDocumentDetail,
  ReportDocumentLinkToSend,
} from "../../../api/models/unified";

interface DocumentSendByEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  document: CPCustomFormReportDocumentDetail;
}

const DocumentSendByEmailModal = ({
  isOpen,
  onClose,
  document,
}: DocumentSendByEmailModalProps) => {
  const { t } = useTranslation();

  const handleSubmit = async (values: ReportDocumentLinkToSend) =>
    await documentsClient.sendByEmail({
      reportDocumentId: document.id,
      values,
    });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t("send_by_email")}>
      <SendByEmailForm
        onSubmit={handleSubmit}
        documentName={document.name}
        onClose={onClose}
      />
    </Modal>
  );
};

export default DocumentSendByEmailModal;
